(function () {
  var timer;

  function partsFor(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: '2-digit',
      month: 'short'
    }).formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return [values.weekday, values.day, values.month].join(' ').toUpperCase();
  }

  function isoLocalDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return [year, month, day].join('-');
  }

  function updateDatelines(root) {
    var now = new Date();
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-tsuki-live-date]').forEach(function (element) {
      element.textContent = partsFor(now);
      element.setAttribute('datetime', isoLocalDate(now));
    });
  }

  function scheduleMidnightUpdate() {
    window.clearTimeout(timer);
    var now = new Date();
    var next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);

    timer = window.setTimeout(function () {
      updateDatelines(document);
      scheduleMidnightUpdate();
    }, next.getTime() - now.getTime());
  }

  updateDatelines(document);
  scheduleMidnightUpdate();

  document.addEventListener('shopify:section:load', function (event) {
    updateDatelines(event.target);
  });
})();
